import React, { useCallback, useEffect, useMemo } from 'react'
import { getTabDecor } from './archiveTabs'

/**
 * Navegación por pestañas — vertical en desktop, horizontal en móvil.
 */
export default function HanArchivesTabs({ tabs = [], activeTab, onTabChange }) {
  const items = useMemo(
    () => (Array.isArray(tabs) ? tabs.filter((t) => t?.id) : []),
    [tabs]
  )

  if (!items.length) return null

  return (
    <nav className="han-archives-tabs han-archives-tabs--vertical" aria-label="Pestañas de los archivos">
      <p className="han-archives-tabs__heading">Índice del archivo</p>
      <ul className="han-archives-tabs__list" role="tablist">
        {items.map((tab) => {
          const decor = getTabDecor(tab.id)
          const isActive = tab.id === activeTab
          const isEmpty = !tab.hasContent
          return (
            <li key={tab.id} className="han-archives-tabs__item" role="presentation">
              <button
                type="button"
                role="tab"
                id={`han-tab-${tab.id}`}
                aria-selected={isActive}
                aria-controls={`han-tabpanel-${tab.id}`}
                className={`han-archives-tabs__btn${isActive ? ' is-active' : ''}${
                  isEmpty ? ' is-empty' : ''
                }`}
                onClick={() => onTabChange(tab.id)}
              >
                <span className="han-archives-tabs__num">{decor.num}</span>
                <span className="han-archives-tabs__label">{tab.title}</span>
              </button>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

/**
 * Subnav de capítulos dentro de la pestaña Historia.
 */
export function HanArchivesHistoriaNav({ sections = [], activeSection, onSectionChange, offset = 96 }) {
  const items = useMemo(
    () => (Array.isArray(sections) ? sections.filter((s) => s?.id && s?.hasContent) : []),
    [sections]
  )

  const scrollToId = useCallback(
    (id) => () => {
      const el = document.getElementById(id)
      if (!el) return
      const rect = el.getBoundingClientRect()
      const top = window.scrollY + rect.top - offset
      window.scrollTo({ top, behavior: 'smooth' })
      onSectionChange(id)
      try {
        window.history.replaceState(null, '', `#${id}`)
      } catch {
        window.location.hash = id
      }
    },
    [offset, onSectionChange]
  )

  useEffect(() => {
    if (items.length && !items.some((s) => s.id === activeSection)) {
      onSectionChange(items[0].id)
    }
  }, [items, activeSection, onSectionChange])

  if (!items.length) return null

  return (
    <nav className="han-archives-historia-nav" aria-label="Capítulos de la historia">
      <ul className="han-archives-historia-nav__list">
        {items.map((section) => (
          <li key={section.id}>
            <button
              type="button"
              className={`han-archives-historia-nav__btn${
                activeSection === section.id ? ' is-active' : ''
              }`}
              onClick={scrollToId(section.id)}
            >
              {section.title}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  )
}
